import { useState } from 'react';
import { apiFetch } from '../../../context/AuthContext';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const useAssignAdmin = (showMessage) => {
  const [showAssignAdminModal, setShowAssignAdminModal] = useState(false);
  const [adminCandidates, setAdminCandidates] = useState([]);
  const [selectedAdminIds, setSelectedAdminIds] = useState([]);
  const [adminSearch, setAdminSearch] = useState('');
  const [loadingAdmins, setLoadingAdmins] = useState(false);

  const openAssignAdmin = async (selectedCompany) => {
    if (!selectedCompany) {
      showMessage('error', 'Please select a company first');
      return;
    }

    setShowAssignAdminModal(true);
    setLoadingAdmins(true);
    setAdminSearch('');
    setSelectedAdminIds([]);

    try {
      // fields=basic: AssignAdminModal renders only sr and infinityCode, so
      // the default ~87-column payload is pure waste on large clients.
      const response = await apiFetch(
        `${BASE_URL}/employees/visibility?clientName=${encodeURIComponent(selectedCompany)}&fields=basic`,
        { method: 'GET' }
      );
      const data = await response.json();
      setAdminCandidates(data?.employees || []);
    } catch (error) {
      console.error('Failed to fetch employees:', error);
      showMessage('error', 'Failed to load employees');
      setAdminCandidates([]);
    } finally {
      setLoadingAdmins(false);
    }
  };

  const handleToggleAdmin = (infinityCode) => {
    setSelectedAdminIds((prev) =>
      prev.includes(infinityCode)
        ? prev.filter((id) => id !== infinityCode)
        : [...prev, infinityCode]
    );
  };

  const handleSaveAdmins = async (selectedCompany) => {
    if (selectedAdminIds.length === 0) {
      showMessage('error', 'Please select at least one employee');
      return;
    }

    setLoadingAdmins(true);
    try {
      const response = await apiFetch(`${BASE_URL}/employees/make-admin`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          infinityCodes: selectedAdminIds,
          clientName: selectedCompany,
        }),
      });

      if (!response.ok) {
        showMessage('error', 'Failed to assign admins');
      } else {
        showMessage('success', 'Admins assigned successfully!');
      }
      setShowAssignAdminModal(false);
      setSelectedAdminIds([]);
    } catch (error) {
      console.error('Failed to assign admins:', error);
      showMessage('error', 'Failed to assign admins');
    } finally {
      setLoadingAdmins(false);
    }
  };

  const closeAssignAdminModal = () => {
    setShowAssignAdminModal(false);
    setSelectedAdminIds([]);
  };

  return {
    showAssignAdminModal,
    adminCandidates,
    selectedAdminIds,
    adminSearch,
    setAdminSearch,
    loadingAdmins,
    openAssignAdmin,
    handleToggleAdmin,
    handleSaveAdmins,
    closeAssignAdminModal,
  };
};